import { useCallback, useState } from 'react';

import { selectHasStagedChanges } from '../state/selectors';
import { useAnalysisDefinitionStore } from '../state/useAnalysisDefinitionStore';
import type { UseAnalysisStagedChangesPillResult } from '../types';

export const useAnalysisStagedChangesPill = (): UseAnalysisStagedChangesPillResult => {
  const hasStagedChanges = useAnalysisDefinitionStore(selectHasStagedChanges);

  const [isSaveOpen, setSaveOpen] = useState(false);
  const [isRevertOpen, setRevertOpen] = useState(false);

  const onSaveClick = useCallback(() => setSaveOpen(true), []);
  const onRevertClick = useCallback(() => setRevertOpen(true), []);
  const onCloseSave = useCallback(() => setSaveOpen(false), []);
  const onCloseRevert = useCallback(() => setRevertOpen(false), []);

  return {
    visible: hasStagedChanges,
    isSaveOpen,
    isRevertOpen,
    onSaveClick,
    onRevertClick,
    onCloseSave,
    onCloseRevert,
  };
};
